import React from "react";
import {RouterProvider} from "react-router-dom";

import {router} from "../router";
import OauthProviders from "../components/oauth/Providers";
import {QueryClientProvider} from "@tanstack/react-query";
import {queryClient} from "../state";
import {ErrorRoot} from "../components/ErrorBoundary";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import RootTheme from "../theme/RootTheme";
import {AppUpdatedMessage} from "../utils/import/AppUpdatedMessage";
import AppModalProvider from "./Dialogs/Provider";
import {PostHogProvider} from "posthog-js/react";
// eslint-disable-next-line import/no-named-as-default
import posthog from "posthog-js";

export default function App() {
  return (
    <React.StrictMode>
      <PostHogProvider client={posthog}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <RootTheme>
            <ErrorRoot>
              <AppModalProvider>
                <OauthProviders>
                  <AppUpdatedMessage />
                  <RouterProvider router={router!} future={{v7_startTransition: true}} />
                </OauthProviders>
              </AppModalProvider>
            </ErrorRoot>
          </RootTheme>
        </QueryClientProvider>
      </PostHogProvider>
    </React.StrictMode>
  );
}
